import React from "react";
import ICONS from "../../../assets/Icons";
import LargePopupRedirect from "../../_utils/CommonPopups/CommonLargePopupRedirect";
import FieldForceTransactionViewAll from "../../../containers/Transactions/FieldForceTransactions/FieldForceTransactionViewAll";

const FieldForceTxnViewAllPopup = ({
  closeFieldForceTxnDetailsModal,
  TxnHistoryid,
  TxnHistoryAccountName,
  categoryName,
  type,
  HistoryPopup,
}) => {
  return (
    <div>
      <LargePopupRedirect
        headerTitle="Transaction history"
        headersubtext="All transactions related to the field force are listed below."
        headerFontWeight="semibold"
        headerFontColor="text-primary"
        headertextSize="font-md"
        fullviewisDisabled={false}
        fullviewenabledTextColor="var(--text-primary)"
        fullviewenabledBgColor="var(--primary-nav)"
        fullviewhoverOption="white"
        fullviewicon={ICONS?.REDIRECT}
        fullviewdisabledBgColor="var(--text-disabled)"
        closeiconbtnType="button"
        closeiconhandleFunction={() => closeFieldForceTxnDetailsModal()}
        closeiconisDisabled={false}
        closeiconenabledBgColor="var(--primary-nav)"
        closeicondisabledBgColor="var(--text-disabled)"
        closeiconhoverOption="white"
        closeicon={ICONS?.CLOSE}
        isbottomSectionneed={false}
        bottomHeaderTextNeed={false}
      >
        <FieldForceTransactionViewAll
          type={type}
          TxnHistoryid={TxnHistoryid}
          TxnHistoryAccountName={TxnHistoryAccountName}
          categoryName={categoryName}
          closeFieldForceTxnDetailsModal={closeFieldForceTxnDetailsModal}
          HistoryPopup={HistoryPopup}
        />
      </LargePopupRedirect>
    </div>
  );
};

export default FieldForceTxnViewAllPopup;
